var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logistics"},_vm._l((_vm.getKeys),function(item,key){return _c('carbon-input',_vm._b({key:key,on:{"input":(e) => _vm.model.setValue(item, e)}},'carbon-input',_vm.model.getProps(item),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }